
document.addEventListener('DOMContentLoaded', () => {
  const formContainer = document.querySelector('.form-container');

  const observer = new MutationObserver((mutationsList, observer) => {
  const form = document.querySelector('form-embed');

if (form) {
  observer.disconnect();
  const shadow = form.shadowRoot;

  const sheet = new CSSStyleSheet();
  sheet.insertRule(`
  :host {
    --form-placeholder-color: var(--body-text-color);
  }
`);
  sheet.insertRule(`
    input, button[aria-expanded], textarea {
      border-radius: 28px !important;
      border: none !important;
      background-color: rgba(var(--color-scheme-text)) !important;
      color: var(--body-text-color) !important;
    }
  `);
  sheet.insertRule(`
    label {
      opacity: 0.7;
    }
  `);
  sheet.insertRule(`
    button[type="submit"]:before {
          content: "";
    position: absolute;
    left: var(--button-drop-shadow-left-size);
    top: var(--button-drop-shadow-top-size);
    height: 100%;
    width: 100%;
    border-radius: 9999px;
    display: var(--button-shadow-display);
    background-color: rgb(var(--color-button-shadow));
    background-image: var(--color-button-shadow);
    border-width: var(--button-shadow-border-width);
    border-color: rgb(var(--color-button-border));
    z-index: -1;
    }
  `);
  sheet.insertRule(`
    button[type="submit"] {
          position: relative;
          padding: 0 !important;
          background-color: transparent !important;
    }
  `);
  sheet.insertRule(`
    button[type="submit"] span {
    display: inline-block;
    cursor: pointer;
    border-radius: 99999px;
    padding: .75rem 1rem;
    text-align: center;
    font-size: var(--font-size-base);
    line-height: var(--base-line-height);
    text-transform: var(--button-text-transform);
    background: rgb(var(--color-button-background));
    color: rgb(var(--color-button-text));
    box-shadow: inset 0 0 0 var(--button-border-width) rgb(var(--color-button-border));
    box-sizing: border-box;
    transition: transform .1s cubic-bezier(.215,.61,.355,1);
    font-family: var(--button-font-stack);
    font-weight: var(--button-font-weight);
    font-style: var(--button-font-style);
    letter-spacing: var(--button-letter-spacing);
    width: 100%;
    }
  `);
  sheet.insertRule(`
    button[type="submit"]:hover span {  
          transform: translate(var(--button-hover-left-size),var(--button-hover-top-size));
    }
  `);
  sheet.insertRule(`
    button[type="submit"]:hover {  
          filter: none;
    }
  `);
  sheet.insertRule (`
    section[class^='_formContainer'], section[class*=' _formContainer']{
      max-width: 700px !important;
      overflow: visible !important
    }
  `)

  shadow.adoptedStyleSheets.push(sheet);
  const submitButton = shadow.querySelector('button[type="submit"]');
      if (submitButton) {
        const hasSpan = Array.from(submitButton.childNodes).some(node =>
          node.nodeType === Node.ELEMENT_NODE && node.tagName === 'SPAN'
        );

        if (!hasSpan) {
          const textNodes = Array.from(submitButton.childNodes).filter(node =>
            node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== ""
          );

          textNodes.forEach(textNode => {
            const span = document.createElement('span');
            span.textContent = textNode.textContent;
            textNode.replaceWith(span);
          });
        }
      }
  formContainer.classList.add('loaded');
}
});

observer.observe(document.body, { childList: true, subtree: true });
});
